import {
    API_ADMIN_GET_ALL_GENERALPARAMETER,
    API_ADMIN_PATCH_GENERALPARAMETER,
    API_GET_ALL_GENERALPARAMETER
} from "../actions/generalParameter";

export function getAllGeneralParameters() {
    return {
        type: API_GET_ALL_GENERALPARAMETER,
        payload: {
            request: {
                url: `/generalParameters`
            }
        }
    };
}

export function adminGetAllGeneralParameters() {
    return {
        type: API_ADMIN_GET_ALL_GENERALPARAMETER,
        payload: {
            request: {
                url: `/admin/generalParameters`
            }
        }
    };
}

export function adminPatchGeneralParameter(generalParameterLibrary) {
    return {
        type: API_ADMIN_PATCH_GENERALPARAMETER,
        payload: {
            request: {
                url: `/admin/generalParameters`,
                method: "PATCH",
                data: generalParameterLibrary
            }
        },

    };
}

